import { useState } from 'react';
import Login from './components/LoginComponent';
import Lists from './components/ListsComponent';

function App() {
  const [user, setUser] = useState(sessionStorage.getItem('user'));
  const [password] = useState(sessionStorage.getItem('password'));

  function render() {
    if (!user || !password) {
      return <Login selectUser={setUser} />;
    } else {
      return <Lists user={user} />;
    }
  }

  return <div className='root'>{render()}</div>;
}

export default App;
